var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "91.08 -789.23 777.84 640.77",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M610.85-451.15 575-487q4-43.38-25.69-68.19T487-576l-35.85-35.85q6.08-1.15 13.54-1.73 7.46-.57 15.31-.57 56.15 0 95.15 39t39 95.15q0 7.85-.57 16.08-.58 8.23-2.73 12.77m131.46 129.92L718-344q36-28 65.5-61.5T833-480q-49-101-144.5-158.5T480-696q-26 0-51 3t-49 10l-27.23-27.23q31.85-11.15 64.42-14.46Q449.77-728 480-728q122.23 0 230.73 65.58Q819.23-596.85 868.92-480q-20.46 46.23-52.34 84.65-31.89 38.43-74.27 74.12m22.61 172.77L647.23-267.69q-29.54 14.77-72.88 25.23Q531-232 480-232q-123 0-230.73-65.58Q141.54-363.15 91.08-480q24.3-57 66.46-104.77 42.15-47.77 92.46-81.15l-101.54-100 23.31-23.31 616.46 617.46zM273.31-641.62q-40.39 26.47-82.31 68.81-41.92 42.35-64 92.81 49 101 144.5 158.5T480-264q40.62 0 81.77-7.73t63.85-17.58L551.38-362q-12.46 7.31-33.38 11.73t-38 4.42q-56.15 0-95.15-39t-39-95.15q0-16.31 5.42-36.85 5.42-20.53 10.73-34.53zm197.15 191.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility_off.427321268a9a1213c81899a2e0a03619.svg";
export { ForwardRef as ReactComponent };